  import React from "react";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Cart from "./pages/Cart";
import { SnackbarProvider } from "notistack";
import { Slide } from "@mui/material";
import Items from "./pages/Items";
import CheckoutPage from "./pages/CheckoutPage";
import OrderPlaced from "./pages/Orderplaced";

const App = () => {
  return (
    <>
      <Router>
        <SnackbarProvider
          TransitionComponent={Slide}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Navbar />
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/cart" element={<Cart />} />
            <Route exact path="/items" element={<Items/>}/>
            <Route exact path="/checkout" element={<CheckoutPage/>}/>
            <Route exact path="/orderplaced" element={<OrderPlaced/>}/>
            
          </Routes>
        </SnackbarProvider>
      </Router>
    </>
  );
};

export default App;
